<div class="avis-container">
  <mat-toolbar style="height: 45px;padding-right: 0;background: rgba(0, 0, 0, 0.87);">
    <span style="color: #FFF;">Avis sur la demande</span>
    <span style="flex: 1 1 auto;"></span>
    <span style="height: 45px;"><mat-icon style="font-size: 45px;width: 45px;height: 45px;color: #ff0a25;cursor: pointer;" (click)="close();">clear</mat-icon></span>
  </mat-toolbar>
  <mat-list>
    <mat-list-item style="height: 10px;"></mat-list-item>
    <mat-list-item style="height: auto;" *ngIf="data?.message_question">
      <span class="avis-line-title">Texte de la demande d'avis :</span>&nbsp;&nbsp;
      <span class="avis-line-content"
            style="text-wrap: wrap;"
            [innerHtml]="data?.message_question | newline">
      </span>
    </mat-list-item>
    <mat-list-item style="height: 10px;"></mat-list-item>
    <mat-list-item style="height: 30px;">
      <span class="avis-line-title">Sollicité :</span>&nbsp;&nbsp;
      <span class="avis-line-content">{{data?.expert_individu_obj?.first_name}} {{data?.expert_individu_obj?.last_name}} {{data?.expert_individu_obj?.email_pro}}</span>
    </mat-list-item>
    <mat-list-item style="height: 30px;">
      <span class="avis-line-title">Répondu le :</span>&nbsp;&nbsp;
      <span class="avis-line-content">{{data?.dt_updated | date: 'dd/MM/yyyy HH:MM'}}</span>
    </mat-list-item>
    <mat-list-item style="height: 30px;">
      <span class="avis-line-title">Avis :</span>&nbsp;&nbsp;
      <span class="avis-line-content" [innerHtml]="sanitizer.bypassSecurityTrustHtml(avisSvc?.getChipAvis(data))"></span>
    </mat-list-item>
    <mat-list-item style="height: 30px;">
      <span class="avis-line-title">Document joint </span>:&nbsp;&nbsp;
      <ng-container *ngIf="data?.attachment_obj && data.attachment_obj.length > 0; else noAttachment">
        <div *ngFor="let f of data.attachment_obj; let last = last">
          <span class="avis-line-content">{{ f.filename }}</span>&nbsp;&nbsp;
          <button mat-icon-button [matTooltip]="'Télécharger ' + f.filename" color="accent"
                  (click)="downloadAttachment(f)">
            <mat-icon>download</mat-icon>
          </button>
          <br *ngIf="!last">
        </div>
      </ng-container>
      <ng-template #noAttachment>
        <div>
          <span class="avis-line-content">aucun fichier joint</span>
        </div>
      </ng-template>
      <br>

    </mat-list-item>
    <mat-list-item style="height: 10px;"></mat-list-item>
    <mat-list-item style="height: auto;">
      <span class="avis-line-title">Motivation :</span>&nbsp;&nbsp;
      <span *ngIf="data?.motivation"
            class="avis-line-content"
            style="text-wrap: wrap;"
            [innerHtml]="data?.motivation | newline"></span>
    </mat-list-item>

    <mat-list-item style="height: 10px;"></mat-list-item>
  </mat-list>
</div>
